import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpenRightMenu: false,
};

const translationSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setIsOpenRightMenu(state, action) {
      state.isOpenRightMenu = action.payload;
    },
  },
});

export const { setIsOpenRightMenu } = translationSlice.actions;
const menuReducer = translationSlice.reducer;

export default menuReducer;
